@if (!erreurRecuperation()) {
  <div>
    <form id="site-carte-form" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label for="selectKPI1">{{ 'KPI.KPI' | translate }} 1</label>
        <ng-select name="selectKPI1" id="selectKPI1" [(ngModel)]="selectedKPI1" (change)="onChangeConfiguration()" [clearable]="true">
          @for (configuration of configurationKPI1(); track configuration) {
            <ng-option [value]="configuration.id">{{ configuration.nom }}</ng-option>
          }
        </ng-select>
      </div>
      <div class="form-group">
        <label for="selectKPI2">{{ 'KPI.KPI' | translate }} 2</label>
        <ng-select name="selectKPI2" id="selectKPI2" [(ngModel)]="selectedKPI2" (change)="onChangeConfiguration()" [clearable]="true">
          @for (configuration of configurationKPI2(); track configuration) {
            <ng-option [value]="configuration.id">{{ configuration.nom }}</ng-option>
          }
        </ng-select>
      </div>
      <div class="form-group">
        <label for="selectKPI3">{{ 'KPI.KPI' | translate }} 3</label>
        <ng-select name="selectKPIThree" id="selectKPI3" [(ngModel)]="selectedKPI3" (change)="onChangeConfiguration()" [clearable]="true">
          @for (configuration of configurationKPI3(); track configuration) {
            <ng-option [value]="configuration.id">{{ configuration.nom }}</ng-option>
          }
        </ng-select>
      </div>
      <div class="form-group">
        <label for="selectKPI4">{{ 'KPI.KPI' | translate }} 4</label>
        <ng-select name="selectKPI4" id="selectKPI4" [(ngModel)]="selectedKPI4" (change)="onChangeConfiguration()" [clearable]="true">
          @for (configuration of configurationKPI4(); track configuration) {
            <ng-option [value]="configuration.id">{{ configuration.nom }}</ng-option>
          }
        </ng-select>
      </div>
      <div class="btn-group" role="group">
        <button type="submit" class="btn btn-outline-success">{{ 'GLOBAL.VALIDER' | translate }}</button>
      </div>
    </form>
  </div>
}
@if (erreurRecuperation()) {
  <div class="custom-alert custom-alert-sm">
    {{'GLOBAL.ERREUR_RECUP_DONNEES' | translate }}
  </div>
}

